<template>
  <div class="modal fade" id="send-message-modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <loading-modal :is-loading="isLoading"/>
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center" style="background: #111; border: 1px solid rgba(255,255,255,0.1); border-radius: 24px; box-shadow: 0 20px 40px rgba(0,0,0,0.5);">
        
        <!-- Close Button (Absolute positioned top right) -->
        <button type="button" class="close position-absolute" data-dismiss="modal" aria-label="Close" 
                style="top: 16px; right: 20px; z-index: 10; opacity: 1; text-shadow: none; background: rgba(255,255,255,0.1); width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; transition: all 0.2s;">
          <i class="fa fa-times text-white font-size-14"></i>
        </button>

        <div class="modal-body pt-0 px-4 px-md-5 pb-4">
          <model-global-message
              :global-errors="globalErrors"
              :message="message"
              @clearMessages="clearMessages()"/>

          <!-- Header Icon & Title -->
          <div class="mb-4 mt-4">
            <div class="d-inline-flex align-items-center justify-content-center mb-3" style="width: 64px; height: 64px; border-radius: 50%; background: linear-gradient(135deg, rgba(229,59,185,0.2) 0%, rgba(243,218,107,0.2) 100%); border: 1px solid rgba(229,59,185,0.3);">
              <i class="fa fa-paper-plane font-size-26" style="background: linear-gradient(90deg, #F3DA6B 0%, #E53BB9 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent;"></i>
            </div>
            <h4 class="text-white font-weight-700 mb-2">Send Message</h4>
            <p class="text-muted font-size-14 mb-0">You will be charged <span class="text-white font-weight-600 font-size-16">${{ pricePerMessage }}</span> for this message.</p>
            
            <div v-if="draftMessage && (draftMessage.text || draftMessage.message)" class="mt-3 p-3 text-left" style="background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px;">
              <p class="text-white font-size-13 mb-0" style="white-space: pre-wrap; font-style: italic; opacity: 0.8; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;">"{{ draftMessage.text || draftMessage.message }}"</p>
            </div>
          </div>

          <!-- Payment Selector -->
          <div class="dropdown w-100 text-left mb-4 mt-2">
            <div class="d-flex align-items-center justify-content-between p-3 cursor-pointer" data-toggle="dropdown" aria-expanded="false" style="background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; transition: all 0.2s ease;">
              <div class="d-flex align-items-center">
                <div class="me-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px; border-radius: 12px; background: rgba(255,255,255,0.05);">
                  <i class="fa fa-credit-card text-muted font-size-18"></i>
                </div>
                <div>
                  <p class="text-muted font-size-12 mb-1" style="line-height: 1;">Paying from</p>
                  <p class="text-white font-size-14 font-weight-500 mb-0" style="line-height: 1;">
                    {{ selectedCard ? getCardDetails(selectedCard) : 'Pay with Stripe (Card / Apple Pay)' }}
                  </p>
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-center" style="width: 28px; height: 28px; background: rgba(255,255,255,0.1); border-radius: 50%;">
                <i class="fa fa-chevron-down text-white font-size-10"></i>
              </div>
            </div>
            
            <div class="dropdown-menu w-100 mt-2 p-2 shadow-lg" style="background: #1e1e1e; border: 1px solid rgba(255,255,255,0.1); border-radius: 16px;">
              <a v-for="(card, index) in cards" :key="index"
                 href="#"
                 @click.prevent="cardSelected(index)"
                 class="dropdown-item d-flex align-items-center py-3 px-3 custom-dropdown-item" style="border-radius: 12px; margin-bottom: 4px; color: #fff; transition: background 0.2s;">
                <div class="d-flex align-items-center justify-content-center me-3" style="width: 32px; height: 32px; border-radius: 8px; background: rgba(255,255,255,0.05);">
                  <i :class="['fa', card.cardId ? 'fa-credit-card' : (card.isAddCard ? 'fa-plus' : 'fa-globe')]" :style="{ color: card.isAddCard ? '#F3DA6B' : 'rgba(255,255,255,0.7)' }"></i>
                </div>
                <div class="d-flex flex-column text-left">
                  <span class="font-size-14 font-weight-500" :style="{ color: card.isAddCard ? '#F3DA6B' : '#fff' }">{{ getCardDetails(card) }}</span>
                  <span v-if="card.isAddCard" class="font-size-11 text-muted">Save card for 1-click checkout</span>
                </div>
                <i class="fa fa-chevron-right ms-auto text-muted font-size-12" v-if="card.isAddCard"></i>
                <i class="fa fa-check ms-auto text-white" v-else-if="selectedCardIndex === index" style="background: #E9609B; border-radius: 50%; padding: 4px; font-size: 10px;"></i>
              </a>
            </div>
          </div>

          <!-- Actions (Side by side) -->
          <div class="mt-2 d-flex align-items-center justify-content-between" style="gap: 12px;">
            <button type="button" class="cp-btn-ghost flex-fill py-2"
                    @click="$emit('editMessage')"
                    data-dismiss="modal">
              Edit Message
            </button>
            <button type="button" class="cp-btn-primary flex-fill py-2"
                    @click="pay">
              <i class="fa fa-paper-plane me-1" v-if="!isLoading"></i>
              <i class="fa fa-spinner fa-spin me-1" v-else></i>
              Send Message
            </button>
          </div>

        </div>
      </div>
    </div>

    <message-payment
      ref="messagePayment"
      @paymentFailed="(error) => {
        isLoading = false;
        if(Array.isArray(error)){
          globalErrors.push(...error);
        } else {
        pushGlobalError(error);
        }
      }"
      @paymentSuccess="() => {
        isLoading = false;
        $emit('messageSent', draftMessage);
        hide();
      }"/>

    <!-- In-Modal Add Card Dialog -->
    <model-add-card 
      ref="addCardModal" 
      id="send_message_add_card_modal" 
      :is-loading="isAddingCard" 
      @save="saveNewCard"></model-add-card>
  </div>
</template>

<script>
import {SERVICE_PAYMENT} from "@/properties/micro-service";
import {mapGetters} from "vuex";
import MessagePayment from "@/components/module/customer/direct-message/shared/MessagePayment";
import {MESSAGE} from "@/common/analytics-service";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import ModelAddCard from "@/components/module/customer/shared/ModelAddCard";
import {modelHttpMixin} from "@/mixin/model-http-mixin";

export default {
  name: "SendMessageModal",
  components: {GlobalMessage, MessagePayment, ModelAddCard},
  mixins: [modelHttpMixin],
  data() {
    return {
      pricePerMessage: null,
      cards: [],
      selectedCardIndex: 0,
      influencerId: null,
      customerId: null,
      draftMessage: null,
      originalCardIndex: null,
      isAddingCard: false
    }
  },
  computed: {
    ...mapGetters(['getUser']),
    selectedCard() {
      if (this.cards && this.selectedCardIndex >= 0 && this.selectedCardIndex < this.cards.length) {
        return this.cards[this.selectedCardIndex];
      }
      return null;
    }
  },
  methods: {
    getCards() {
      let url = `${SERVICE_PAYMENT}/api/v1/stripe/customers/${this.getUser.id}/cards`;
      this.getData(url, (cards) => {
        let cardList = cards || [];
        let optionList = [];
        if (cardList.length > 0) {
          optionList.push(...cardList);
        }
        optionList.push({ brand: 'Add new card', isAddCard: true });
        optionList.push({ brand: 'Pay with Stripe (Card / Apple Pay)', isOnline: true });
        this.cards = optionList;
        this.setDefaultCardIndex(cardList);
      }, () => {
        this.cards = [
          { brand: 'Add new card', isAddCard: true },
          { brand: 'Pay with Stripe (Card / Apple Pay)', isOnline: true }
        ];
        this.selectedCardIndex = 1;
      });
    },
    setDefaultCardIndex(cardList) {
      if (this.$route.query.cardAdded) {
        let index = this.cards.findIndex((card) => card.cardId == this.$route.query.cardAdded);
        if (index !== -1) {
          this.selectedCardIndex = index;
          this.originalCardIndex = this.selectedCardIndex;
          return;
        }
      }
      if (cardList && cardList.length > 0) {
        let defaultIdx = this.cards.findIndex((card) => card.defaultCard === true && card.cardId);
        this.selectedCardIndex = defaultIdx !== -1 ? defaultIdx : 0;
      } else {
        let onlineIdx = this.cards.findIndex((card) => card.isOnline);
        this.selectedCardIndex = onlineIdx !== -1 ? onlineIdx : 0;
      }
      this.originalCardIndex = this.selectedCardIndex;
    },
    getCardDetails(card) {
      if (!card) return 'Pay with Stripe (Card / Apple Pay)';
      if (card.cardId) {
        return `${card.brand} .... ${card.last4Digit}`;
      } else {
        return card.brand || 'Pay with Stripe (Card / Apple Pay)';
      }
    },
    show(influencerId, customerId, draftMessage, pricePerMessage) {
      $('#send-message-modal').modal({ backdrop: 'static', keyboard: false });
      this.influencerId = influencerId;
      this.customerId = customerId;
      this.draftMessage = draftMessage;
      this.pricePerMessage = pricePerMessage;
      this.selectedCardIndex = 0;
      this.originalCardIndex = null;
      this.cards = [];
      this.getCards();
    },
    hide() {
      $('#send-message-modal').modal('hide');
    },
    cardSelected(index) {
      let card = this.cards[index];
      if (card && card.isAddCard) {
        this.addNewCard();
      } else {
        this.selectedCardIndex = index;
      }
    },
    markAsDefaultCard(fn) {
      for (let i = 0; i < this.cards.length; i++) {
        this.cards[i].defaultCard = false;
      }
      this.cards[this.selectedCardIndex].defaultCard = true;
      let card = this.cards[this.selectedCardIndex];
      let url = `${SERVICE_PAYMENT}/api/v1/stripe/customers/${this.getUser.id}/cards/${card.cardId}/`;
      this.patchData(url, card, (data) => {
        fn();
      });
    },
    pay() {
      let currentCard = this.cards[this.selectedCardIndex];
      let hasCard = currentCard && currentCard.cardId;
      let mode = hasCard ? 'Offline' : 'Online';

      if (hasCard && this.originalCardIndex !== this.selectedCardIndex) {
        this.markAsDefaultCard(() => {
          this.isLoading = true;
          this.$refs.messagePayment.pay(this.influencerId, this.customerId,
            this.draftMessage.id, MESSAGE, mode);
        });
      } else {
        this.isLoading = true;
        this.$refs.messagePayment.pay(this.influencerId, this.customerId,
          this.draftMessage.id, MESSAGE, mode);
      }
    },
    addNewCard() {
      this.$nextTick(() => {
        if (this.$refs.addCardModal) {
          this.$refs.addCardModal.show();
        }
      });
    },
    saveNewCard(newCard) {
      this.isAddingCard = true;
      let url = `${SERVICE_PAYMENT}/api/v1/stripe/customers/${this.getUser.id}/cards`;
      this.postData(url, newCard, (data) => {
        this.isAddingCard = false;
        let insertIdx = this.cards.findIndex(c => c.isAddCard);
        if (insertIdx !== -1) {
          this.cards.splice(insertIdx, 0, data);
          this.selectedCardIndex = insertIdx;
        } else {
          this.cards.unshift(data);
          this.selectedCardIndex = 0;
        }
        this.originalCardIndex = this.selectedCardIndex;
        if (this.$refs.addCardModal) {
          this.$refs.addCardModal.hide();
        }
      }, () => {
        this.isAddingCard = false;
      });
    }
  }

}
</script>
<style scoped>
.dropdown-menu.show{
  display: block !important;
}
.padding-class{
  padding: 0px !important;
}
.dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after {
  margin-left: 0;
  margin-top: 0.5rem;
  margin-left: 1rem;
  font-size: 2rem;
}
</style>

